import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'to-door-asap-choice',
  styleUrls: ['./to-door-asap-choice.component.scss'],
  template: `
    <div class="d-flex justify-content-between align-items-baseline flex-wrap">
      <div class="d-flex me-2">
        <div class="asap-choice-label me-2">
          {{ 'bakerySite.expressOrdering.common.pickupTime' | translate }}:
        </div>

        <div class="asap-choice-val">
          <ng-content select="[asap-time]"></ng-content>
        </div>
      </div>

      <div class="text-blue pointer pick-later"
           [translate]="'bakerySite.expressOrdering.common.pickLater'"
           (click)="pickLatter.emit()">
        Pick later time instead
      </div>
    </div>

    <div class="d-flex mt-2">
      <div class="asap-choice-label me-2">
        {{ 'orderProcess.delivery.deliveryForms.deliveryPrice' | translate }}:
      </div>

      <div class="asap-choice-val">
        <ng-content select="[asap-price]"></ng-content>
      </div>
    </div>
  `
})
export class ToDoorAsapChoiceComponent implements OnInit {
  @Output() pickLatter = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

}
